/*eslint-disable*/
import {
  Button,
  CardContent,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  DialogContentText,
  FormControl,
  Icon,
  LinearProgress,
  TextField,
  Chip,
  Avatar
} from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import { InMemoryCache } from "apollo-cache-inmemory";
import { ApolloClient } from "apollo-client";
import { createUploadLink } from "apollo-upload-client";
import avatar from "assets/img/faces/avatar1.jpg";
import imagePlaceholder from "assets/img/imageplaceholder.png";
import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardIcon from "components/Card/CardIcon.jsx";
// core components
import GridItem from "components/Grid/GridItem.jsx";
import FormInput from "components/Wrappers/materialUIWrappers/components/FormInput";
import { fileUploadServerPath } from "constants.js";
import gql from "graphql-tag";
import { GetUserId, GetUserToken, Logout } from "helpers/UserHelper";
import { brokerageBrProfile } from "queries/BrokerageBrProfile";
import { BrokerageBrProfileUpdate } from "queries/Profile/mutations";
import { updatePassword } from "queries/updatePassword";
import React, { Component } from "react";
import { compose, graphql, Mutation } from "react-apollo";
import Dropzone from "react-dropzone";
import { connect } from "react-redux";
import { Redirect } from "react-router";
import { changeAvatar } from "reducers/LoginReducer";
import { showSnack, successWarning } from "reducers/NotificationReducer";
import { Field, reduxForm } from "redux-form";
import store from "store";

const CHANGEAVATAR = "sure-quote/Login/CHANGEAVATAR";

const client = new ApolloClient({
  link: createUploadLink({ uri: fileUploadServerPath }),
  cache: new InMemoryCache()
});

const uploadFileMutation = gql`
  mutation($file: Upload!, $id: String!) {
    uploadFileWithId(file: $file, id: $id)
  }
`;

const brokerageImageMutation = gql`
  mutation($file: Upload!, $id: String!) {
    uploadBrokerageImage(file: $file, id: $id)
  }
`;

const required = value => (value ? undefined : "Required");

function isEmptyOrSpaces(str) {
  return str === undefined || str === null || str.match(/^ *$/) !== null;
}

class BrokerageBrokerProfile extends Component {
  constructor(props) {
    super(props);
  }

  state = {
    open: false,
    avatarPath: "",
    brokerageLogoPath: "",

    oldPassword: "",
    newPassword: "",
    confirmNewPassword: "",

    formInitiazed: false,
    checkValidation: false,
    showInfo: false,
    dialogTitle: "",
    dialogText: ""
  };

  handleStateChange = (event, prop) => {
    this.setState({ [prop]: event.target.value });
  };

  handleClickOpenDialog = () => {
    this.setState({ open: true });
  };

  handleCloseDialog = () => {
    this.setState({
      open: false,
      confirmNewPassword: "",
      newPassword: "",
      oldPassword: ""
    });
  };

  handleResetPassword = () => {
    if (
      isEmptyOrSpaces(this.state.newPassword) ||
      isEmptyOrSpaces(this.state.confirmNewPassword) ||
      isEmptyOrSpaces(this.state.oldPassword)
    ) {
      store.dispatch(
        showSnack({
          message: "Password cannot be empty.",
          color: "danger"
        })
      );
    } else if (this.state.newPassword !== this.state.confirmNewPassword) {
      store.dispatch(
        showSnack({
          message: "Password do not match.",
          color: "danger"
        })
      );
    } else {
      var input = {
        oldPass: this.state.oldPassword,
        newPass: this.state.newPassword,
        brokerId: GetUserId(),
        token: GetUserToken()
      };

      var miniMe = this.props;
      this.props
        .UpdatePassword({
          variables: {
            input
          }
        })
        .then(resp => {
          store.dispatch(
            successWarning({
              open: true,
              title: "Updated Successfully.",
              onConfirm: () => this.setState({ open: false })
            })
          );
        })
        .catch(error => {
          store.dispatch(
            showSnack({
              message:
                "There was an error updating your information : " + error,
              color: "danger"
            })
          );
        });
    }
  };

  openShowInfo = (title, text) => {
    this.setState({ showInfo: true, dialogTitle: title, dialogText: text });
  };

  closeShowInfo = () => {
    this.setState({ showInfo: false, dialogTitle: "", dialogText: "" });
  };

  saveChanges = () => {
    if (store.getState().form.BrokerageBr.syncErrors) {
      store.dispatch(
        showSnack({
          message: "Invalid Information",
          color: "danger"
        })
      );
      this.setState({ checkValidation: true });
      this.forceUpdate();
    } else {
      this.setState({ checkValidation: false });

      var input = {
        userId: GetUserId(),
        data: store.getState().form.BrokerageBr.values,
        token: GetUserToken()
      };

      this.props
        .BrokerageBrProfileUpdate({
          variables: {
            input
          }
        })
        .then(resp => {
          store.dispatch(
            successWarning({
              open: true,
              title: "Profile Updated."
            })
          );
        })
        .catch(error => {
          store.dispatch(
            showSnack({
              message: "There was an error updating your profile : " + error,
              color: "danger"
            })
          );
        });
    }
  };

  initializeForm = profile => {
    this.props.initialize({
      email: profile.email,
      name: profile.name,
      surname: profile.surname,
      contactPhoneNumber: profile.user_phone_number,
      contactEmail: profile.sbad_KP_contact_email,
      brokerageName: profile.sbad_brokerageName,
      fsbNumber: profile.sbad_fsb,
      sbad_streetAddress: profile.sbad_streetAddress,
      brokeragePhoneNumber: profile.sbad_contact_phone,
      brokerageEmail: profile.sbad_contact_email
    });

    this.setState({ formInitiazed: true });
  };

  render() {
    if (this.props.data.loading) {
      return <LinearProgress />;
    }

    var { data } = this.props;
    if (
      data.error &&
      data.error.message &&
      data.error.message === "GraphQL error: invalid token"
    ) {
      Logout();
      return <Redirect to="/app/portal/login" />;
    }

    var profile = data.BrokerageBrProfile;

    if (!this.state.formInitiazed) {
      this.initializeForm(profile);
    }

    let avatarPath = avatar;
    if (this.state.avatarPath !== "") {
      avatarPath = this.state.avatarPath;
    } else if (profile.su_pp_path !== null && profile.su_pp_path !== "") {
      avatarPath = profile.su_pp_path;
    }

    let brokerageLogoPath = imagePlaceholder;
    if (this.state.brokerageLogoPath !== "") {
      brokerageLogoPath = this.state.brokerageLogoPath;
    } else if (
      profile.sbad_brokerageLogoRef !== null &&
      profile.sbad_brokerageLogoRef !== ""
    ) {
      brokerageLogoPath = profile.sbad_brokerageLogoRef;
    }

    return (
      <div>
        <Grid container>
          <GridItem xs={12} sm={12} md={10} style={{flexBasis: "100%", maxWidth: "100%", margin: 'auto' }}>
            <Card style={{marginTop:"0px"}}>
              <CardHeader>
                <CardIcon color="sqLightBlue" className="cardIconTopRight">
                  <Icon style={{ color: "white" }}>person</Icon>
                </CardIcon>
                <Typography variant="headline" className="centerCell">
                  Your Profile
                </Typography>
                <div
                  style={{
                    borderBottom: "1px solid #cccccc69",
                    paddingBottom: "12px",
                    margin: "0px auto",
                    width: "50%"
                  }}
                />
              </CardHeader>
              <CardContent>
                <Grid container>
                  <GridItem
                    xs={12}
                    sm={12}
                    md={6}
                    style={{ marginBottom: "25px" }}
                  >
                    <Card style={{ margin: "0px" }}>
                      <CardContent>
                        <Grid container>
                          <GridItem xs={12} sm={12} md={12}>
                            <Typography
                              variant="headline"
                              className="centerCell"
                            >
                              Your Details
                            </Typography>
                            <div
                              style={{
                                borderBottom: "1px solid #cccccc69",
                                paddingBottom: "12px",
                                margin: "0px auto 15px auto",
                                width: "50%"
                              }}
                            />
                          </GridItem>
                          <GridItem
                            xs={12}
                            sm={12}
                            md={12}
                            style={{ height: "90px" }}
                          >
                            <Mutation
                              client={client}
                              mutation={uploadFileMutation}
                              onCompleted={data => {
                                this.setState({
                                  avatarPath: data.uploadFileWithId
                                });
                                store.dispatch(
                                  changeAvatar({
                                    type: CHANGEAVATAR,
                                    props: data.uploadFileWithId
                                  })
                                );
                              }}
                            >
                              {mutate => (
                                <div style={{ textAlign: "center" }}>
                                  <a
                                    href="#pablo"
                                    onClick={e => e.preventDefault()}
                                  >
                                    <img
                                      className="avatarImg"
                                      src={avatarPath}
                                      alt="..."
                                      style={{
                                        width: "60px",
                                        height: "60px",
                                        margin: "0px auto",
                                        cursor: "default"
                                      }}
                                    />
                                  </a>
                                  <Dropzone
                                    style={{
                                      width: "fit-content",
                                      height: "fit-content",
                                      border: "none",
                                      margin: "0px auto",
                                      marginTop: "10px"
                                    }}
                                    onDrop={([file]) =>
                                      mutate({
                                        variables: {
                                          file,
                                          id: store.getState().login.userID
                                        }
                                      })
                                    }
                                    accept="image/jpeg, image/png"
                                  >
                                    <div
                                      style={{
                                        display: "flex",
                                        position: "relative"
                                      }}
                                    >
                                      <Chip
                                        className="smallChip"
                                        avatar={
                                          <Avatar
                                            style={{
                                              backgroundColor: "#6c5cab",
                                              color: "white"
                                            }}
                                          >
                                            <Icon>edit</Icon>
                                          </Avatar>
                                        }
                                        variant="outlined"
                                        label={
                                          <Typography
                                            style={{
                                              color: "white"
                                            }}
                                          >
                                            Edit Picture
                                          </Typography>
                                        }
                                        color="secondary"
                                        style={{
                                          backgroundColor: "#a59fff",
                                          color: "white",
                                          cursor: "pointer"
                                        }}
                                      />
                                    </div>
                                  </Dropzone>
                                </div>
                              )}
                            </Mutation>
                          </GridItem>
                          <GridItem xs={12} sm={12} md={12} style={{marginTop:"25px"}}>
                            <FormControl
                              fullWidth
                              className="spacedFormControl"
                            >
                              <Field
                                component={FormInput}
                                checkValidation={this.state.checkValidation}
                                name="email"
                                label="User Email (used to log in)"
                                readOnly={true}
                              />
                            </FormControl>
                          </GridItem>
                          <GridItem xs={12} sm={12} md={6}>
                            <FormControl
                              fullWidth
                              className="spacedFormControl"
                            >
                              <Field
                                component={FormInput}
                                checkValidation={this.state.checkValidation}
                                name="name"
                                label="Name"
                                validate={[required]}
                              />
                            </FormControl>
                          </GridItem>
                          <GridItem xs={12} sm={12} md={6}>
                            <FormControl
                              fullWidth
                              className="spacedFormControl"
                            >
                              <Field
                                component={FormInput}
                                checkValidation={this.state.checkValidation}
                                name="surname"
                                label="Surname"
                                validate={[required]}
                              />
                            </FormControl>
                          </GridItem>
                          <GridItem xs={12} sm={12} md={6}>
                            <FormControl
                              fullWidth
                              className="spacedFormControl"
                            >
                              <Field
                                component={FormInput}
                                checkValidation={this.state.checkValidation}
                                name="contactPhoneNumber"
                                label="Phone No."
                              />
                            </FormControl>
                          </GridItem>
                          <GridItem xs={12} sm={12} md={6}>
                            <FormControl
                              fullWidth
                              className="spacedFormControl"
                            >
                              <Field
                                component={FormInput}
                                checkValidation={this.state.checkValidation}
                                name="contactEmail"
                                label="Contact Email"
                              />
                            </FormControl>
                          </GridItem>
                          <Grid
                            item
                            xs={12}
                            sm={12}
                            md={12}
                            style={{ marginTop: "16px" }}
                          >
                            <Grid container>
                              <GridItem xs={12} sm={6} md={6}>
                                <Typography variant="subheading">
                                  Sure Quote App Code
                                </Typography>
                                <Typography
                                  variant="caption"
                                  className="typographyLinkBasic"
                                  onClick={() =>
                                    this.openShowInfo(
                                      "Sure Quote App Code?",
                                      "This is the Code that you send to your Clients when they download the My Broker App to link them with you. This will allow them to actively update their information for you and send you direct Messenges."
                                    )
                                  }
                                >
                                  What's this?
                                </Typography>
                              </GridItem>
                              <GridItem xs={12} sm={6} md={6}>
                                <TextField
                                  fullWidth
                                  defaultValue={profile.sbd_broker_app_code}
                                  InputProps={{
                                    readOnly: true
                                  }}
                                />
                              </GridItem>
                            </Grid>
                          </Grid>
                        </Grid>
                      </CardContent>
                    </Card>
                  </GridItem>
                  <GridItem
                    xs={12}
                    sm={12}
                    md={6}
                    style={{ marginBottom: "25px" }}
                  >
                    <Card style={{ margin: "0px" }}>
                      <CardContent>
                        <Grid container>
                          <GridItem xs={12} sm={12} md={12}>
                            <Typography
                              variant="headline"
                              className="centerCell"
                            >
                              Brokerage Details
                            </Typography>
                            <div
                              style={{
                                borderBottom: "1px solid #cccccc69",
                                paddingBottom: "12px",
                                margin: "0px auto 15px auto",
                                width: "50%"
                              }}
                            />
                          </GridItem>

                          <GridItem
                            xs={12}
                            sm={12}
                            md={12}
                            style={{ textAlign: "center" }}
                          >
                            <img
                              src={brokerageLogoPath}
                              alt="..."
                              style={
                                brokerageLogoPath !== imagePlaceholder
                                  ? {
                                      width: "200px",
                                      height: "auto",
                                      maxHeight: "90px"
                                    }
                                  : { width: "60px", height: "60px" }
                              }
                            />
                          </GridItem>
                          <GridItem xs={12} sm={12} md={12}>
                            <Mutation
                              client={client}
                              mutation={brokerageImageMutation}
                              onCompleted={data => {
                                this.setState({
                                  brokerageLogoPath: data.uploadBrokerageImage
                                });
                                this.forceUpdate();
                              }}
                            >
                              {mutate => (
                                <Dropzone
                                  style={{
                                    width: "fit-content",
                                    height: "fit-content",
                                    border: "none",
                                    margin: "0px auto",
                                    marginTop: "10px"
                                  }}
                                  onDrop={([file]) =>
                                    mutate({
                                      variables: {
                                        file,
                                        id: store.getState().login.userID
                                      }
                                    })
                                  }
                                  accept="image/jpeg, image/png"
                                >
                                  <Chip
                                    className="smallChip"
                                    avatar={
                                      <Avatar
                                        style={{
                                          backgroundColor: "#6c5cab",
                                          color: "white"
                                        }}
                                      >
                                        <Icon>edit</Icon>
                                      </Avatar>
                                    }
                                    variant="outlined"
                                    label={
                                      <Typography
                                        style={{
                                          color: "white"
                                        }}
                                      >
                                        Edit Logo
                                      </Typography>
                                    }
                                    color="secondary"
                                    style={{
                                      backgroundColor: "#a59fff",
                                      color: "white",
                                      cursor: "pointer"
                                    }}
                                  />
                                </Dropzone>
                              )}
                            </Mutation>
                          </GridItem>
                          <GridItem xs={12} sm={12} md={12}>
                            <FormControl
                              fullWidth
                              className="spacedFormControl"
                            >
                              <Field
                                component={FormInput}
                                checkValidation={this.state.checkValidation}
                                name="brokerageName"
                                label="Brokerage Name"
                                validate={[required]}
                              />
                            </FormControl>
                          </GridItem>
                          <GridItem xs={12} sm={12} md={6}>
                            <FormControl
                              fullWidth
                              className="spacedFormControl"
                            >
                              <Field
                                component={FormInput}
                                checkValidation={this.state.checkValidation}
                                name="fsbNumber"
                                label="FSB No."
                                readOnly={true}
                              />
                            </FormControl>
                          </GridItem>

                          <GridItem xs={12} sm={12} md={6}>
                            <FormControl
                              fullWidth
                              className="spacedFormControl"
                            >
                              <Field
                                component={FormInput}
                                checkValidation={this.state.checkValidation}
                                name="sbad_streetAddress"
                                label="Address"
                              />
                            </FormControl>
                          </GridItem>

                          <GridItem xs={12} sm={12} md={6}>
                            <FormControl
                              fullWidth
                              className="spacedFormControl"
                            >
                              <Field
                                component={FormInput}
                                checkValidation={this.state.checkValidation}
                                name="brokeragePhoneNumber"
                                label="Phone No."
                              />
                            </FormControl>
                          </GridItem>
                          <GridItem xs={12} sm={12} md={6}>
                            <FormControl
                              fullWidth
                              className="spacedFormControl"
                            >
                              <Field
                                component={FormInput}
                                checkValidation={this.state.checkValidation}
                                name="brokerageEmail"
                                label="Brokerage Email"
                              />
                            </FormControl>
                          </GridItem>
                          <Grid
                            item
                            xs={12}
                            sm={12}
                            md={12}
                            style={{ marginTop: "16px" }}
                          >
                            <Grid container>
                              <GridItem xs={12} sm={6} md={6}>
                                <Typography variant="subheading">
                                  Brokerage Code
                                </Typography>
                                <Typography
                                  variant="caption"
                                  className="typographyLinkBasic"
                                  onClick={() =>
                                    this.openShowInfo(
                                      "Brokerage Code?",
                                      "This is the code Sure Quote sends your Brokers and Assistants when you invite them to register on Sure Quote. We use this code to authenticate and link the Brokers and Assistants to your Brokerage."
                                    )
                                  }
                                >
                                  What's this?
                                </Typography>
                                <Dialog
                                  open={this.state.showInfo}
                                  onClose={this.closeShowInfo}
                                >
                                  <DialogTitle>
                                    {this.state.dialogTitle}
                                  </DialogTitle>
                                  <DialogContent>
                                    <DialogContentText>
                                      {this.state.dialogText}
                                    </DialogContentText>
                                  </DialogContent>
                                  <DialogActions>
                                    <Button
                                      onClick={this.closeShowInfo}
                                      color="primary"
                                      autoFocus
                                    >
                                      Ok
                                    </Button>
                                  </DialogActions>
                                </Dialog>
                              </GridItem>
                              <GridItem xs={12} sm={6} md={6}>
                                <TextField
                                  fullWidth
                                  defaultValue={profile.sbad_brokerage_code}
                                  InputProps={{
                                    readOnly: true
                                  }}
                                />
                              </GridItem>
                            </Grid>
                          </Grid>
                        </Grid>
                      </CardContent>
                    </Card>
                  </GridItem>
                  <GridItem
                    xs={12}
                    sm={12}
                    md={12}
                    style={{ marginTop: "10px", textAlign: "center" }}
                  >
                    <Button
                      variant="outlined"
                      className="outlinedButton"
                      onClick={() => this.saveChanges()}
                      style={{ color: "#55526f", margin: "0px auto" }}
                    >
                      Save Changes
                      <Icon style={{ marginLeft: "5px" }}>check</Icon>
                    </Button>
                  </GridItem>
                  <GridItem
                    xs={12}
                    sm={12}
                    md={12}
                    style={{ marginTop: "35px", textAlign: "center" }}
                  >
                    <Typography
                      variant="body1"
                      style={{
                        color: "#0000008a"
                      }}
                      className="typographyLinkBasic"
                      onClick={this.handleClickOpenDialog}
                    >
                      Reset Password
                    </Typography>
                    <Dialog
                      open={this.state.open}
                      onClose={this.handleCloseDialog}
                      aria-labelledby="form-dialog-title"
                      className="centerFixedDialog"
                    >
                      <DialogTitle id="form-dialog-title">
                        {"Reset Password"}
                      </DialogTitle>
                      <DialogContent>
                        <TextField
                          label="Old Password"
                          fullWidth
                          onChange={e =>
                            this.handleStateChange(e, "oldPassword")
                          }
                          value={this.state.oldPassword}
                          autoComplete="off"
                          type="password"
                        />
                        <TextField
                          label="New Password"
                          fullWidth
                          onChange={e =>
                            this.handleStateChange(e, "newPassword")
                          }
                          value={this.state.newPassword}
                          autoComplete="off"
                          type="password"
                        />
                        <TextField
                          label="Confirm New Password"
                          fullWidth
                          onChange={e =>
                            this.handleStateChange(e, "confirmNewPassword")
                          }
                          value={this.state.confirmNewPassword}
                          autoComplete="off"
                          type="password"
                        />
                      </DialogContent>
                      <DialogActions>
                        <Button
                          onClick={this.handleCloseDialog}
                          color="primary"
                        >
                          Cancel
                        </Button>
                        <Button
                          onClick={this.handleResetPassword}
                          color="primary"
                        >
                          SAVE
                        </Button>
                      </DialogActions>
                    </Dialog>
                  </GridItem>
                </Grid>
              </CardContent>
            </Card>
          </GridItem>
        </Grid>
      </div>
    );
  }
}

BrokerageBrokerProfile = graphql(brokerageBrProfile, {
  options: () => ({ fetchPolicy: "network-only" }),
  props: props => {
    if (props.data.error) {
    }

    return { ...props };
  }
})(BrokerageBrokerProfile);

BrokerageBrokerProfile = connect(state => ({
  brokerId: GetUserId(),
  token: GetUserToken()
}))(BrokerageBrokerProfile);

BrokerageBrokerProfile = compose(
  graphql(updatePassword, { name: "UpdatePassword" }),
  graphql(BrokerageBrProfileUpdate, { name: "BrokerageBrProfileUpdate" })
)(BrokerageBrokerProfile);

BrokerageBrokerProfile = reduxForm({
  form: "BrokerageBr",
  destroyOnUnmount: true
})(BrokerageBrokerProfile);

export default BrokerageBrokerProfile;



// WEBPACK FOOTER //
// ./src/views/Profile/BrokerageBrokerProfile.jsx